module.exports = __webpack_public_path__ + "static/media/tree-step-1.9f78b722.svg";